import { apiClient } from '@/api/client'
import type { AuthResponse, LoginDto, User } from '@/types/api.types'

export const authService = {
  async login(dto: LoginDto): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/api/auth/login', dto)
    return data
  },
  async me(): Promise<User> {
    const { data } = await apiClient.get<User>('/api/auth/me')
    return data
  },
}
